import React from 'react'
import { motion } from 'framer-motion/dist/framer-motion'
import MotionLink from '../../MotionLink'
import Waves from './Waves'

const Main = ({ data }) => {
    return (
        <motion.div
            key="mga-home-main"
            className="mga-home-section__main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
        >
            <div className="mga-section__wrapper">
                <motion.h1
                    initial={{ opacity: 0, y: '150%' }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                >
                    {data.content.title}
                </motion.h1>
                <motion.div
                    className="mga-home-section__main__info"
                    initial={{ opacity: 0, y: '100%' }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.75, duration: 1 }}
                    dangerouslySetInnerHTML={{ __html: data.content.text }}
                />
                <motion.div
                    initial={{ opacity: 0, y: '300%' }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 1.25, duration: 1 }}
                >
                    <MotionLink
                        to={data.content.link}
                    >
                        {data.content.more}
                    </MotionLink>
                </motion.div>
            </div>
            <Waves />
        </motion.div>
    )
}

export default Main